import { RatingSelector } from 'component/ratingselector';
import { useState } from 'react';
import { component, componentWithVariants, demoFile, variant } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('component/ratingselector');

const ratingLabels = [t('Strongly yes'), t('Yes with reservations'), t("It's complicated"), t('No with reservations'), t('Strongly no')];
const ratingColors = ['green', 'lightgreen', 'yellow', 'orange', 'red'];

function RatingSelectorDemo({ value = null }: { value?: number | null }) {
    const [rating, setRating] = useState<number | null>(value);
    return (
        <RatingSelector
            onChangeValue={setRating}
            optionColors={ratingColors}
            optionLabels={ratingLabels}
            placeholder='Rate your opinion'
            value={rating}
        />
    );
}

componentWithVariants('RatingSelector', RatingSelectorDemo, {}, [variant('Interactive'), variant('Preselected', { args: { value: 3 } })]);
